var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-card van-hairline--top-bottom",staticStyle:{"border-top":"1px solid #D8D8D8","border-bottom":"1px solid #D8D8D8"}},[_c('p',{staticStyle:{"display":"flex","align-items":"center","font-size":"16px","font-weight":"bold","color":"#00C896"}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }